<template>
  <div class="howItWorksStepperContainer w-100 mt-4 flex-between-center">
    <button
      class="btn"
      data-testid="how-it-works-previous-button"
      @click="previous"
    >
      <ChevronLeft fill="#FFF" height="18px" width="11px" />
    </button>
    <div class="stepList flex-1 flex-between-center px-5">
      <template
        v-for="i in dotCount"
      >
        <button
          :id="`${i}-step-button`"
          :key="`${i}-button`"
          class="btnDot p-0 no-scale flex-center"
          :data-step-label="`STEP ${i}`"
          :data-testid="`how-it-works-${i}-step-button`"
          @click="activeDot = i"
        >
          <div class="dot" :class="dotClass(i)"></div>
        </button>
        <BPopover
          :key="`${i}-popover`"
          custom-class="stepPopover"
          :disabled="true"
          :offset="popoverOffset(i)"
          placement="top"
          :show="activeDot === i"
          :target="`${i}-step-button`"
        >
          <HowItWorksPopoverContents :index="i" />
        </BPopover>
        <div v-if="i !== dotCount" :key="`${i}-line`" class="line flex-1" :class="dotClass(i)" />
      </template>
    </div>
    <button
      class="btn"
      data-testid="how-it-works-next-button"
      @click="next"
    >
      <ChevronRight fill="#FFF" height="18px" width="11px" />
    </button>
  </div>
</template>

<script>
import { ChevronLeft, ChevronRight } from '@js/web/components/icons';
import { baseStepper } from '../mixins/baseStepper';

export default {
  name: 'HowItWorksStepper',
  components: {
    ChevronLeft,
    ChevronRight
  },
  mixins: [ baseStepper ],
  methods: {
    next() {
      if (this.activeDot < this.dotCount) {
        this.activeDot++;
      }
    },
    popoverOffset(index) {
      if (index === 1) {
        return 100;
      } else if (index === this.dotCount) {
        return -130;
      } else {
        return 0;
      }
    },
    previous() {
      if (this.activeDot > 1) {
        this.activeDot--;
      }
    }
  }
};
</script>

<style lang="scss">
@import '@sass/vue-imports.scss';

.stepPopover {
  background: $brand-dark;
  border: 2px solid #FFF;
  border-radius: 5px;
  max-width: 330px;
  z-index: 1000;

  > .arrow {
    &:before {
      border-top-color: #FFF;
    }
    &:after {
      bottom: 2px;
      border-top-color: $brand-dark;
    }
  }

  .popover-body {
    color: #FFF;
  }
}

.howItWorksStepperContainer {
  height: 250px;

  .line {
    height: 2px;
    background: #FFF;
    transition: all .3s ease-in-out;

    &.dulled {
      background: $corduroy;
    }

    &.active {
      background: linear-gradient(270deg, $corduroy 12.16%, $primary 89.83%);
    }
  }

  .btnDot {
    position: relative;
    width: 54px;
    height: 54px;
    background: $brand-dark;

    &:hover {
      .dot {
        width: 24px;
        height: 24px;
      }
      >span {
        bottom: -26px;
      }
    }

    .dot {
      border-radius: 50%;
      width: 16px;
      height: 16px;
      background: #FFF;
      transition: all .1s ease-in-out;

      &.dulled {
        background: $corduroy;
      }

      &.active {
        width: 24px;
        height: 24px;
        background: $primary;
      }
    }

    &:after {
      content: attr(data-step-label);
      color: #FFF;
      position: absolute;
      bottom: -10px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>